import {
  FC, useEffect, useMemo, useRef,
} from 'react'
import { Form, Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import * as Yup from 'yup'

import style from '@src/pages/Login/Login.module.scss'
import { Button } from '@src/components/Button/Button'
import { login } from '@src/store/ducks/auth/thunks'
import { AppDispatch } from '@src/store/store'
import { FieldFormik } from '@src/components/common/FieldFormik/FieldFormik'
import { AuthFormEnum } from '@src/types/auth'
import { validateForm } from '@src/messages/validateForm'
import { CheckBoxFormik } from '@src/components/common/CheckBoxFormik/CheckBoxFormik'
import { phoneRegexp } from '@src/lib/regex'
import { selectBackError } from '@src/store/ducks/auth/selectors'

type LoginFormProps = {
  type: AuthFormEnum
  isLoading: boolean
}

export const LoginForm: FC<LoginFormProps> = ({ isLoading, type }) => {
  const dispatch = useDispatch<AppDispatch>()
  const backError = useSelector(selectBackError)
  const formRef = useRef<any>()

  const validationSchema = useMemo(() => (
    Yup.object().shape({
      loginUser: Yup.string().when('type', {
        is: AuthFormEnum.PHONE,
        then: Yup.string().matches(phoneRegexp, validateForm.phone).required(validateForm.required),
        otherwise: Yup.string().required(validateForm.required).typeError('Логин должен содержать только числа'),
      }),
      password: Yup.string().required(validateForm.required),
    })
  ), [])

  const initialValues = useMemo(() => ({
    type,
    loginUser: '',
    password: '',
    rememberMe: true,
  }), [type])

  useEffect(() => {
    if (backError) {
      formRef.current.setFieldError('password', backError)
    }
  }, [backError])

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={({ loginUser, password }) => {
        dispatch(login(loginUser, password))
      }}
      validationSchema={validationSchema}
      innerRef={formRef}
      enableReinitialize
    >
      {() => (
        <Form>
          <div className={style.box_1}>
            <FieldFormik
              name="loginUser"
              placeholder={type === AuthFormEnum.CONTRACT ? 'Логин' : '+375 (ХХ) ХХХ ХХ ХХ'}
              mask={type === AuthFormEnum.PHONE ? '+{375} (00) 000-00-00' : undefined}
              label={type === AuthFormEnum.CONTRACT ? 'Введите ваш логин' : 'Введите ваш номер телефона'}
            />
            <FieldFormik
              name="password"
              type="password"
              placeholder="*******"
              label="Введите пароль"
            />
          </div>
          <div className={style.rememberMe}>
            <CheckBoxFormik name="rememberMe" label="Запомнить меня" />
            <a
              href={`/recovery-password/${type}`}
              className={`${style.btn}`}
            >
              Забыли пароль?
            </a>
          </div>
          <div className={`${style.btn}`}>
            {type === AuthFormEnum.PHONE && (
              <NavLink
                to="/registration"
              >
                <Button
                  type="text"
                  outline
                  className={style.btnSize}
                >
                  Стать клиентом
                </Button>
              </NavLink>
            )}
            <Button
              loading={isLoading}
              htmlType="submit"
              type="primary"
              className={style.btnSize}
            >
              Выполнить вход
            </Button>

          </div>
          {/* <Info name="Выполнить вход" className={style.infoSize} /> */}
        </Form>
      )}
    </Formik>
  )
}
